import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useTypedSelector } from "../../../../../hooks/useTypedSelector";
import Sticker from "../../../../../components/elements/sticker/Sticker";
import FlexLine from "../../../../../components/elements/flexLine/FlexLine";
import Container from "../../../../../components/elements/container/Container";

import { TextType } from "../../../../../types/baseType";
import Tx from "../../../../../types/naming";
import st from "./styles.module.scss";

import CropRotationChart from "./chart";
import ChartHeader from "../../../../../components/elements/chart/ChartHeader";
import { stickerLoadingWithCrop } from "../../../phases";
import { CircleLabel } from "../../../works/detalization/dynamics";
import * as Highcharts from "highcharts";
import { columnRangeLegendToggler } from "../../index";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../../../store";
import { array, identity } from "fp-ts";
import { DetalizationCropState } from "../../../../../store/reducers/dashboard/crops/detalization";
import { Empty } from "./empty";
import Legend from "@elements/Legend/Legend";

interface CropsRotationDashboard {
    baseCropId?: any;
}

const CropsRotationDashboard: FC<CropsRotationDashboard> = (props) => {
    useNavigate();
    const [chartApi, setChartApi] = useState<Highcharts.Chart>()

    let {
        data
    } = useTypedSelector((state) => state.dashCropDetalization);

    const { selected } = useTypedSelector(state => state.cropSelector);

    if (selected && array.isEmpty(selected)) {
        return <Empty/>
    }

    return (
        <Sticker className={st.sticker}>
            <FlexLine textType={TextType.Header}>
                <ChartHeader>{Tx.CropRotation}</ChartHeader>
            </FlexLine>
            <Container >
                <div className={st.container}>
                    <div className={st.container__legend}>
                        <Legend
                            rowVariant={'nameValue'}
                            rows={
                                data.cultivatedArea.filter(i => i.cropId !== 'unknown')
                                    .map(i => ({
                                        id: i.cropId,
                                        color: i.color,
                                        values: [
                                            <CircleLabel align={'start'} color={i.color} name={i.crops}/>
                                        ]
                                    }))
                            }
                            onClick={columnRangeLegendToggler(chartApi)}/>
                    </div>
                    <div className={st.container__chart}>
                        <CropRotationChart
                            chart={chartApi}
                            apiCallback={setChartApi}
                            listOfCropsForDash={data.cultivatedArea}
                        />
                    </div>
                </div>
            </Container>
        </Sticker>
    );
};

export default stickerLoadingWithCrop(
    createSelector((state: RootState) => state.dashCropDetalization, identity.of<DetalizationCropState>),
    actions => actions.fetchCropDetalization
)(CropsRotationDashboard);